import script from "./prime-configuration.vue?vue&type=script&setup=true&lang=js"
export * from "./prime-configuration.vue?vue&type=script&setup=true&lang=js"

import "./prime-configuration.vue?vue&type=style&index=0&id=dc15e34c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc15e34c"]])

export default __exports__